module.exports = __webpack_public_path__ + "img/calendarDownloadIcon.f266cbb3.svg";